import type { SectorFormData } from '../types';

export const SECTOR_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	areaId: 'Área',
	size: 'Tamanho',
	plantingDate: 'Data de Plantio',
	lineSpacing: 'Espaçamento entre Linhas',
	plantSpacing: 'Espaçamento entre Plantas',
	amountOfPlants: 'Quantidade de Plantas',
};

export const DEFAULT_SECTOR_FORM: SectorFormData = {
	name: '',
	areaId: '',
	size: 0,
	plantingDate: '',
	lineSpacing: 0,
	plantSpacing: 0,
	amountOfPlants: 0,
	irrigation: {
		irrigationEfficiency: '',
	},
};
